import api from "../..";
import type { Video, GetVideoByIdParams } from "./types";

export const getVideos = async (): Promise<Video[]> => {

  return await api.get("/admin/video/")
  .then(res => res.data.data)
  .catch(() => {return []});
};

export const getVideoById = async ({ uuid }: GetVideoByIdParams): Promise<Video | null> => {

  return await api.get(`/admin/video/${uuid}/`)
  .then(res => res.data.data)
  .catch(() => {return null});
};
